const baseURL = 'https://empresa.socioslodge.com';

export default baseURL;
